import { Form, Input, Select, Row, Col, Switch } from "antd";
import {
  EVENT_ACCESS_OPTIONS,
  SHOW_IN_LISTINGS_COPY,
  isShownInListings,
} from "../../../commons/events.helpers";
import useAuthStore from "stores/AuthStore/AuthStore";
import { textInputValidator } from "commons/helper";

function Step1Details({ communities, loadingData }) {
  const { isRootUser } = useAuthStore();
  // Visible to every partner (not only community leads); undefined means ON.
  const showInListings = isShownInListings(
    Form.useWatch("show_in_listings", { preserve: true })
  );
  return (
    <div className="space-y-2">
      <h2 className="text-lg font-semibold mb-6">Event Details</h2>

      <Row gutter={[24, 0]}>
        {isRootUser && (
          <Col xs={24} md={12}>
            <Form.Item
              name="community_id"
              label={
                <span>
                  Community{" "}
                  <span
                    style={{
                      color: "rgba(247, 241, 241, 0.54)",
                      fontSize: 11,
                      fontWeight: 400,
                    }}
                  >
                    (required for Members Only)
                  </span>
                </span>
              }
            >
              <Select
                showSearch
                loading={loadingData}
                placeholder="Select a community"
                optionFilterProp="label"
                allowClear
                options={communities.map((c) => ({
                  value: c.community_id,
                  label: c.display_name || c.name,
                }))}
              />
            </Form.Item>
          </Col>
        )}
        {isRootUser && (
          <Col xs={24} md={12}>
            <Form.Item
              name="event_access"
              label="Event Access"
              rules={[
                { required: true, message: "Please select access level" },
              ]}
            >
              <Select
                disabled={!isRootUser}
                placeholder="Select access level"
                options={EVENT_ACCESS_OPTIONS}
              />
            </Form.Item>
          </Col>
        )}
      </Row>

      <Form.Item
        name="title"
        label="Event Title"
        rules={[
          {
            required: true,
            whitespace: true,
            min: 3,
            message: "Title must be at least 3 characters",
          },
          { validator: textInputValidator },
        ]}
      >
        <Input
          placeholder="e.g. Techno Night Mumbai 2026"
          size="large"
          maxLength={100}
          showCount
        />
      </Form.Item>

      <Form.Item
        name="description"
        label="Description"
        rules={[
          {
            required: true,
            whitespace: true,
            message: "Please enter a description",
          },
          { validator: textInputValidator },
        ]}
      >
        <Input.TextArea
          rows={4}
          placeholder="Describe what attendees can expect…"
          maxLength={500}
          showCount
        />
      </Form.Item>

      <Row gutter={[24, 0]}>
        {/* <Col xs={24} md={12}>
          <Form.Item
            name="tags"
            label="Tags (max 5)"
            rules={[
              {
                validator(_, value) {
                  if (!value?.length) return Promise.resolve();
                  if ((value ?? []).length > 5)
                    return Promise.reject(new Error("Maximum 5 tags allowed."));
                  const invalid = value.filter((t) => t.trim().length > 20);
                  return invalid.length > 0
                    ? Promise.reject(
                        new Error(
                          `Invalid tag(s): ${invalid.join(", ")}. Each tag must be 20 characters or fewer.`
                        )
                      )
                    : Promise.resolve();
                },
              },
            ]}
          >
            <Select
              mode="tags"
              placeholder="Add tags (press Enter to add)"
              tokenSeparators={[",", " "]}
              maxTagCount={5}
            />
          </Form.Item>
        </Col> */}
      </Row>

      <Form.Item
        name="show_in_listings"
        label={SHOW_IN_LISTINGS_COPY.label}
        valuePropName="checked"
        tooltip={SHOW_IN_LISTINGS_COPY.tooltip}
        extra={
          <>
            <span aria-live="polite">
              {showInListings ? (
                SHOW_IN_LISTINGS_COPY.helperOn
              ) : (
                <>
                  <strong>{SHOW_IN_LISTINGS_COPY.badge}.</strong>{" "}
                  {SHOW_IN_LISTINGS_COPY.helperOff}
                </>
              )}
            </span>
            <br />
            <span className="text-muted-foreground">
              {SHOW_IN_LISTINGS_COPY.helperDelay}
            </span>
          </>
        }
      >
        <Switch aria-label={SHOW_IN_LISTINGS_COPY.switchAriaLabel} />
      </Form.Item>
    </div>
  );
}

export default Step1Details;
